import { useCallback } from "react";
import { Button, type ButtonPropsType } from "@core/components/ui/Button";
import { useUiStore } from "@core/stores/uiStore";
import { setCookie } from "@core/utils/cookieUtil";
import { getLoginUrl } from "@core/utils/urlUtil";

export default function LoginLink({ children, className, variant, size, returnUrl }: { children?: React.ReactNode; className?: string; variant: ButtonPropsType["variant"]; size: ButtonPropsType["size"]; returnUrl?: string }) {
  const network = useUiStore((state) => state.network);
  const url = getLoginUrl(network, returnUrl);

  const clickHandler = useCallback(() => {
    // 쿠키에 plaync로 로그인헸었다는 값 저장
    setCookie({ key: "isPlayncLogin", value: "true", path: "/" });

    // 로그인 페이지로 이동
    window.location.href = url;
  }, [url]);

  return (
    <Button {...{ className, variant, size }} asChild={true} onClick={clickHandler}>
      <a href={url}>{children ?? "로그인"}</a>
    </Button>
  );
}
